module.exports = "<app-header></app-header>\r\n<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-management/user-management-main/user-management-main.component.html
// module id = ./src/app/user-management/user-management-main/user-management-main.component.html
// module chunks = main